import { render } from "./accountProduct.vue?vue&type=template&id=61b68325"
import script from "./accountProduct.vue?vue&type=script&lang=js"
export * from "./accountProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__